export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  FORGOT_PASSWORD: "/forgotten-password",
  REGISTER: "/register",
};
